/**
 * Browser stand-in for Node's `util` module, wired as webpack's
 * `resolve.fallback.util` (like `queryString.js` for `querystring`). Replaces
 * the `util` npm polyfill (3PP Reduce, W-24065533).
 *
 * The only bundled consumer is @mulesoft/ang-search-component's
 * QueryExecutor, which reads `util.TextDecoder` when no global `TextDecoder`
 * exists. The npm polyfill never exported `TextDecoder`, so this shim only
 * exposes the browser's own encoders. If a new dependency needs more of
 * `util`, add it here (check webpack stats for modules requesting 'util').
 */
const browserGlobal = typeof window === 'undefined' ? {} : window;

export const { TextDecoder, TextEncoder } = browserGlobal;
